export default "__VITE_ASSET__cfd25095__"